module.exports = __webpack_public_path__ + "static/img/srhd_ic_success@2x.207e9f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/srhd_ic_success@2x.png
// module id = iK4D
// module chunks = 1